import { faPencil, faShoppingBag } from '@fortawesome/pro-light-svg-icons'
import { Dispatch, SetStateAction, useCallback } from 'react'
import { twinFetchPostJSON, twinFetchPostText } from '../../../../../../utils/globals/data'
import TwinTrans from '../../../../../../baseComponents/TwinTrans'
import { TwinDictionary, getDifferencesTwoDicts } from '../../../../../../utils/globals/dictionary'
import { OnChangeOrderAddProduct } from '../TableComponents/Inputs/OrderSearchProductInput/types'
import { getNextOrder } from '../../../../../../baseComponents/TwinTable/functions'
import { checkNewDiscountByFinalPrice, checkNewDiscountByFinalPriceVat, checkNewDiscountByFinalPriceWithDiscountsWithVat } from '../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Displays/function'
import { ITLayoutTableModalOpen } from '../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { InputTableLayoutData, InputTableURLsTable } from '../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { BuildedOrder, TableConfiguration } from '../../../../../../baseComponents/TwinTable/types'
import { calculateQuoteOrderProductPrices } from '@teinor/erp/prices/quote/quoteProducts'
import { recalculateAllQuoteOrderRows } from '@teinor/erp/prices/quote/calculate'
import { TableWithoutVirtualListingRowProps } from '../../../../../../baseComponents/TwinTable/TableWithoutVirtualListing/types'
import { flushSync } from 'react-dom'
import { TableWithoutDefaultRowRenderer } from '../../../../../../baseComponents/TwinTable/TableWithoutVirtualListing'
import NullComponent from '../../../../../../baseComponents/NullComponent'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { ITIconToolTip } from '../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Displays'
import { processedTypesInversed } from '@teinor/erp/types/company/order/general'
import { updateTableQuantityScaled, updateTableQuantityScaledByWeight } from '../TableComponents/ModalsOrderTable/ModalEditAddonProductOrder/functions'
import TwinIcon from '../../../../../../baseComponents/TwinIcon'
import { calculatePriceWithoutVat, numToDecimals } from '@teinor/erp/prices'


interface OrderTableRenderProps {
    completeData: InputTableLayoutData
}

export const useOrderTableRender = ({ completeData }: OrderTableRenderProps) => {
    const {t} = useTwinTranslation()
    const modidyVariantText = t('modifyQuantities', 'Modificar cantidades')
    const addCombinedHeader = useCallback((props: TableWithoutVirtualListingRowProps, setOpenModal: React.Dispatch<React.SetStateAction<ITLayoutTableModalOpen>>) => {
        let className = props.className
        const columnsKeyNotChange = ['url', 'name', 'reference', 'referenceAndName', 'dragLine']
        const newColumns = []
        for (const column of props.columns) {
            newColumns.push(JSON.parse(JSON.stringify(column)))
            if(!columnsKeyNotChange.includes(column.id)){
                newColumns[newColumns.length-1].customRender =()=>  <NullComponent/>
            }else {
                newColumns[newColumns.length - 1].customRender = column.customRender
            }
            if (column.id === 'editProduct'){
                newColumns[newColumns.length - 1].customRender = () => <ITIconToolTip icon={faPencil} className='' message={modidyVariantText} id={'editProduct' + props.rowIndex} />
            }
        }
        return (
            <div {...props} className={(className || '') + ' flex items-center rowproductcombined_variant_header input_table_header_row'} onClick={() => setOpenModal({ allRowData: { ...props.rowData, completeData }, type: 'complexProduct'})}>
                <TableWithoutDefaultRowRenderer {...props} className={className} key={props.rowData?.id || props.rowIndex} columns={newColumns} />
            </div>
        )
    }, [completeData, modidyVariantText])

    const addCombinedHeaderFinalized = useCallback((props: TableWithoutVirtualListingRowProps) => {
        let className = props.className
        const columnsKeyNotChange = ['url', 'name', 'reference', 'referenceAndName']
        const newColumns = []
        for (const column of props.columns) {
            newColumns.push(JSON.parse(JSON.stringify(column)))
            if (!columnsKeyNotChange.includes(column.id)) {
                newColumns[newColumns.length - 1].customRender = () => <NullComponent />
            } else {
                newColumns[newColumns.length - 1].customRender = column.customRender
            }   
        }

        return (
            <div {...props} className={(className || '') + ' table_row flex items-center rowproductcombined_variant_header input_table_header_row'}>
                <TableWithoutDefaultRowRenderer {...props} className={className} key={props.rowData?.id || props.rowIndex} columns={newColumns} />
            </div>
        )
    }, [])

    const addButtonRowRender = useCallback((props: TableWithoutVirtualListingRowProps, addNewProductLine: () => void) => {
        if(!props.style){
            props.style = {}
        }
        return (
            <div {...props}>
                <div className=' table_row flex items-center justify-center w-full bg-gray-EF add_product_row cursor-pointer input_table_header_row' onClick={addNewProductLine}>
                    <span>+<span className='ml-5'><TwinTrans transKey='addLine'>Añadir fila</TwinTrans></span></span>
                </div>
            </div>
        )
    }, [])

    const addExtraProps = useCallback((props: TableWithoutVirtualListingRowProps) => {
        let isFiltered = completeData?.filteredTableData?.length ? true : false
        let myTable = completeData?.filteredTableData || completeData.tableData
        let className = (props.className || '')
        const myParentKey = props.rowData?.['Product.ProductId'] ? 'Product.ProductId' : 'OrderProductId'
        const ParentId = props.rowData[myParentKey]
        const isProcessed = props?.rowData?.processed < processedTypesInversed['unprocessed']
        if (!props?.rowData?.finishedStep) {
            if (props?.rowData?.processed === processedTypesInversed['canceled']) {
                className += ' bg-red-FE'
            } else if ((isProcessed && parseFloat(props?.rowData?.quantity) > 0)) {
                className += ' bg-green-F2'
            } 
        }
        if (ParentId) {
            const ProductVariantGroupId = props.rowData['Product.ProductVariantGroupId']
            const OrderVariantGroupId = props.rowData['OrderVariantGroupId']
            className += ProductVariantGroupId ? ' row_productcombined_variant' : ' row_productcombined_addon'
            let next = myTable[props.rowIndex+1]
            if(isFiltered && next){
                next = completeData.tableData?.[completeData?.dictPosTableData?.[next?.id]]
            }
            if (!next || !next[myParentKey] || next[myParentKey] !== ParentId) {
                const nextHaveDiffVariant = props.rowData['OrderVariantGroupId'] !== next?.['OrderVariantGroupId']
                className += (ProductVariantGroupId || nextHaveDiffVariant) ? ' row_productcombined_variant_last' : ' row_productcombined_addon_last'
            }
            if (OrderVariantGroupId){
                className += ' row_order_variant_group'
            }
        }else {
            className += ' row_single_product'
        }
        return {className}
    }, [completeData.tableData, completeData?.filteredTableData, completeData.dictPosTableData])

    const addOrderHeader = useCallback((props: TableWithoutVirtualListingRowProps, multiHeaderName: string) => {
        let className = props.className
        const customName = props.rowData?.custom_name ? ' - ' + props.rowData?.custom_name : ''
        return (
            <div {...props} className={className + ' items-center bg-green-E9 input_table_header_row px-8 py-12'}>
                <TwinIcon className='text-green-21 ' icon={faShoppingBag} fontSize={21} />
                <span className='ml-10 medium14'>{multiHeaderName} #{props.rowData.reference}{customName} - {props.rowData.order_date}{props.rowData.notes ? (' - ' + props.rowData.notes) : ''}</span>
            </div>
        )
    }, [])

    return { addExtraProps, addButtonRowRender, addCombinedHeader, addCombinedHeaderFinalized, addOrderHeader }
}

export const prepareOrderProductTableExtraCost = (newData: InputTableLayoutData | null, oldData: InputTableLayoutData | null, triggerId?: number) => {
    const tableUpdate = []
    let triggerElement = {}
    if (newData?.tableData && oldData?.tableData) {
        for (const key in newData?.tableData) {
            const newProd = newData?.tableData[key]
            const oldProd = oldData?.tableData[key]
            if (newProd.finalUnitPriceCostWithoutTax !== oldProd.finalUnitPriceCostWithoutTax || newProd.rowPriceWithoutTax !== oldProd.rowPriceWithoutTax) {
                const compare = ['rowPriceWithoutTax', 'extraLineDiscount', 'extraLineRecharge', 'extraLineDiscountWithTax', 'rowPriceWithTax', 'finalUnitPriceCostWithoutTax', 'finalUnitPriceWithTax', 'finalUnitPriceWithoutTax', 'rowPriceWithoutTaxPrev']
                const items = getDifferencesTwoDicts(oldProd, newProd, compare)
                tableUpdate.push({
                    id: newProd.id,
                    ...items,
                })
                if (triggerId && triggerId === newProd.id) {
                    triggerElement = {
                        id: newProd.id,
                        ...items,
                    }
                }
            }
        }
    }
    return { tableUpdate, triggerElement }
}
export interface OnChangeOrderTableLogicProps {
    setCompleteData: Dispatch<SetStateAction<InputTableLayoutData | null>>
    getCompleteData: (order?: BuildedOrder) => Promise<void>
    inputTableURLs: InputTableURLsTable
    setTableConfiguration: React.Dispatch<React.SetStateAction<TableConfiguration>>
    completeData: InputTableLayoutData
}

export const useOnChangeOrderTableLogic = ({ inputTableURLs, getCompleteData, setCompleteData, setTableConfiguration, completeData }: OnChangeOrderTableLogicProps) => {
    const changeOrder = useCallback((fieldName: string) => {
        setTableConfiguration((old) => {
            const copy = JSON.parse(JSON.stringify(old))
            const order = getNextOrder(fieldName, copy.order, 'asc')
            return { ...copy, order}
        })
        getCompleteData()
    }, [getCompleteData, setTableConfiguration])

    const changeSingleField = useCallback((fieldName: string, value: string) => {
        setTableConfiguration((oldTableConfiguration) => {
            const copy = JSON.parse(JSON.stringify(oldTableConfiguration))
            return {
                ...copy,
                offset: 0, 
                singleFieldsSearch: {
                    ...copy.singleFieldsSearch,
                    [fieldName]: value
                }
            }
        })
    }, [setTableConfiguration])
    
    const onChangeTotals = useCallback(async (rowIndex: number, keyValue: string, value: string) => {
        return flushSync(async () => {
            let myProduct: { [fieldName: string]: any } = {}
            let relatedProducts: any[] = []
            let relatedProductsWeight: any[] = []
            await setCompleteData((old) => {
                let shouldUpdateField = true
                const copyOld = JSON.parse(JSON.stringify(old))
                if (!copyOld) {
                    return null
                }
                if (copyOld?.tableData) {
                    myProduct['_oldQuantity'] = copyOld.tableData[rowIndex]['quantity']
                    myProduct['_oldCalculatedQuantity'] = copyOld.tableData[rowIndex]['calculatedQuantity']
                    if (keyValue === 'typeDiscount') {
                        copyOld.tableData[rowIndex]['discount'] = 0
                    } else if (keyValue.includes('finalPriceToRecalculate')) {
                        let info: TwinDictionary = {}
                        const parsedValue = parseFloat(value)
                        const myField = keyValue === 'finalPriceToRecalculateWithVat' ? 'rowPriceWithTaxAndTotalDiscount' : 'rowPriceWithoutTaxAndTotalDiscount'
                        const myFieldValue = parseFloat(copyOld.tableData[rowIndex]?.[myField])
                        shouldUpdateField = false
                        if (parsedValue !== myFieldValue){
                            copyOld.tableData[rowIndex]['discount'] = 0
                            recalculateAllQuoteOrderRows(copyOld)
                            let myFunction = keyValue === 'finalPriceToRecalculateWithVat' ? checkNewDiscountByFinalPriceVat : checkNewDiscountByFinalPrice
                            if (old?.discountsWithVat) {
                                myFunction = checkNewDiscountByFinalPriceWithDiscountsWithVat 
                            }
                            info = myFunction(copyOld.tableData[rowIndex], value)
                            copyOld.tableData[rowIndex] = {
                                ...copyOld.tableData[rowIndex],
                                ...info
                            }
                            myProduct = {
                                ...info
                            }
                        }
                    } else if ((keyValue === 'initialUnitPriceWithoutTax' && parseFloat(String(value)) !== parseFloat(String(copyOld.tableData[rowIndex].initialUnitPriceWithoutTax))) || (keyValue === 'initialUnitPriceWithTax' && parseFloat(String(value)) !== parseFloat(String(copyOld.tableData[rowIndex].initialUnitPriceWithTax)))) {
                        myProduct['manualPrice'] = true
                        copyOld.tableData[rowIndex]['manualPrice'] = true
                    }
                    const quantityEqLabels = parseInt(copyOld.tableData[rowIndex]['quantity']) ===
                        parseInt(copyOld.tableData[rowIndex]['label'])
                    const emptyLabel = copyOld.tableData[rowIndex]['label'] === ''
                    if (keyValue === 'quantity' && (quantityEqLabels || emptyLabel)) {
                        copyOld.tableData[rowIndex]['label'] = parseInt(value)
                        myProduct['label'] = parseInt(value)
                    }
                    if (keyValue === 'quantity' || keyValue === 'wasteWeight') {
                        if (keyValue === 'wasteWeight' && (value === '')) {
                            value = '0'
                            copyOld.tableData[rowIndex]['wasteWeight'] = undefined
                            shouldUpdateField = false
                        }
                        let wasteWeight = keyValue === 'wasteWeight' ? value : copyOld.tableData[rowIndex].wasteWeight || 0
                        let quantity = parseFloat(String(keyValue === 'quantity' ? value : copyOld.tableData[rowIndex].quantity || 0))
                        const calculatedQuantity = numToDecimals(((parseFloat(String(wasteWeight)) / 100) * quantity) + quantity, 8)
                        let myQuantity2 = 0
                        if (copyOld.tableData[rowIndex].quantity2base) {
                            myQuantity2 = numToDecimals(copyOld.tableData[rowIndex]['quantity2base'] * quantity, 8)
                        }
                        copyOld.tableData[rowIndex]['quantity2'] = myQuantity2
                        myProduct.quantity2 = myQuantity2
                        myProduct.quantity = quantity
                        myProduct.calculatedQuantity = calculatedQuantity
                        copyOld.tableData[rowIndex].quantity = quantity
                        copyOld.tableData[rowIndex].calculatedQuantity = calculatedQuantity
                    }
                    if (shouldUpdateField) {
                        copyOld.tableData[rowIndex][keyValue] = value
                    }
                    const subProduct = copyOld?.tableData[rowIndex]
                    const prices = calculateQuoteOrderProductPrices(
                        {
                            ...subProduct,
                            discount: subProduct.discount && parseFloat(subProduct.discount),
                            taxUsed: parseFloat(subProduct.taxUsed),
                            pricePerUnitPrice: 0
                        } as any
                    )

                    copyOld.tableData[rowIndex] = {
                        ...subProduct,
                        ...prices
                    }
                    if (keyValue === 'typeDiscount') {
                        myProduct['discount'] = ''
                    }
                    myProduct = {
                        ...myProduct,
                        id: subProduct.id,
                        [keyValue]: value,
                    }
                    if (keyValue === 'quantity' || keyValue === 'wasteWeight') {
                        relatedProducts = updateTableQuantityScaled(copyOld, copyOld.tableData[rowIndex].id, copyOld.tableData[rowIndex]['quantity'])
                        relatedProductsWeight = updateTableQuantityScaledByWeight(copyOld, copyOld.tableData[rowIndex].id, copyOld.tableData[rowIndex]['quantity2'] || '0')
                    }
                    if (keyValue === 'quantity2') {
                        relatedProducts = updateTableQuantityScaledByWeight(copyOld, copyOld.tableData[rowIndex].id, copyOld.tableData[rowIndex]['quantity2'] || '0')
                    }
                    if (keyValue === 'initialUnitPriceWithTax') {
                        copyOld.tableData[rowIndex].initialUnitPriceWithoutTax = calculatePriceWithoutVat(parseFloat(value || '0'), subProduct.taxUsed, subProduct.taxUsed2 || 0) 
                    }
                    recalculateAllQuoteOrderRows(copyOld)
                    const { triggerElement } = prepareOrderProductTableExtraCost(copyOld, old, subProduct.id)
                    if (triggerElement) {
                        myProduct = { ...myProduct, ...triggerElement }
                    }
                    return { ...copyOld }
                }
                return { ...copyOld }
            })
            if (myProduct['initialUnitPriceWithoutTax'] === '') {
                myProduct['initialUnitPriceWithoutTax'] = 0
            }
            if (myProduct['quantity'] === '') {
                myProduct['quantity'] = 0
            }
            if (myProduct['OrderAccountId'] === '') {
                myProduct['OrderAccountId'] = null
            }
            return { myProduct, relatedProducts: [...relatedProducts, ...relatedProductsWeight] }
        })
    }, [setCompleteData])
    
    const onChangeTotalsFetch = useCallback(async (rowIndex: number, keyValue: string, value: string) => {
        const { myProduct, relatedProducts } = await onChangeTotals(rowIndex, keyValue, value)
        const result = await twinFetchPostJSON(inputTableURLs.updateData, { ...myProduct, relatedProducts })
        if (result && Object.keys(result).length) {
            setCompleteData((old) => {
                let shouldUpdateField = true
                const copyOld = JSON.parse(JSON.stringify(old))
                if (!copyOld) {
                    return null
                }
                if (copyOld?.tableData) {
                    for (const myKeyValue in result) {
                        const myVal = result[myKeyValue]
                        const quantityEqLabels = parseInt(copyOld.tableData[rowIndex]['quantity']) === parseInt(copyOld.tableData[rowIndex]['label'])
                        const emptyLabel = copyOld.tableData[rowIndex]['label'] === ''
                        if (myKeyValue === 'quantity' && (quantityEqLabels || emptyLabel)) {
                            copyOld.tableData[rowIndex]['label'] = parseInt(myVal)
                            myProduct['label'] = parseInt(myVal)
                        }
                        if (shouldUpdateField) {
                            copyOld.tableData[rowIndex][myKeyValue] = myVal
                        }
                    }
                    const subProduct = copyOld?.tableData[rowIndex]
                    const prices = calculateQuoteOrderProductPrices(
                        {
                            ...subProduct,
                            discount: subProduct.discount && parseFloat(subProduct.discount),
                            taxUsed: parseFloat(subProduct.taxUsed),
                            pricePerUnitPrice: 0
                        } as any
                    )
                    copyOld.tableData[rowIndex] = {
                        ...subProduct,
                        ...prices
                    }
                    recalculateAllQuoteOrderRows(copyOld)
                    return { ...copyOld }
                }
                return { ...copyOld }
            })
        }
    }, [inputTableURLs, onChangeTotals, setCompleteData])

    const onChange = useCallback(async (rowIndex: number, keyValue: string, value: string) => {
        return flushSync(async () => {
            let myProduct: { [fieldName: string]: any } = {}
            await setCompleteData((old) => {
                if (!old) {
                    return null
                }
                if (old?.tableData) {
                    if (keyValue === 'WarehouseId') {
                        old.tableData[rowIndex]['unique_number'] = null
                    }
                    old.tableData[rowIndex][keyValue] = value
                    const subProduct = old.tableData[rowIndex]
                    myProduct = {
                        id: subProduct.id,
                        [keyValue]: value
                    }
                }
                return { ...old }
            })
            return myProduct
        })
    }, [setCompleteData])

    const onChangeFetch = useCallback(async (rowIndex: number, keyValue: string, value: string) => {
        const myProduct = await onChange(rowIndex, keyValue, value)
        await twinFetchPostText(inputTableURLs.updateData, { ...myProduct })
    }, [inputTableURLs, onChange])

    const addNewProductLine = useCallback(() => {
        setCompleteData((old) => {
            if (!old) {
                return null
            } else {
                const newOld = JSON.parse(JSON.stringify(old))
                if (newOld.tableData.length && newOld.header) {
                    let id: number
                    if (newOld.tableData.length === 1) {
                        id = 1
                    } else {
                        id = newOld.tableData[(newOld.tableData.length - 2)].id + 1
                    }
                    newOld.tableData.splice(newOld.tableData.length - 1, 0, { id })
                    return { ...newOld }
                }
                return { ...newOld }
            }
        })
        setTimeout(() => {
            //@ts-ignore
            document.querySelector('.input_table_searchproductinput input')?.focus()
        }, 100)
    }, [setCompleteData])

    const onChangeAdd: OnChangeOrderAddProduct = useCallback(async (product) => {
        let lastAccoundId = null
        for (let i = completeData?.tableData?.length - 1; i > -1; i--){
            if (completeData?.tableData?.[i].id && completeData?.tableData?.[i].OrderId) {
                lastAccoundId = completeData?.tableData?.[i]?.OrderAccountId
                break
            }
        }
        const update = await twinFetchPostText(inputTableURLs.createData[0], { ...inputTableURLs.createData[1], ProductId: product.id, OrderAccountId: lastAccoundId || null, SuperProductParentId: product.ProductId, uniqueNumber: product.unique_number})
        if (update) {
            await getCompleteData()
        }
        addNewProductLine()
    }, [getCompleteData, inputTableURLs, completeData?.tableData, addNewProductLine])

    const onChangeUpdate = useCallback(async () => {
        getCompleteData()
    }, [getCompleteData])
    
    const onChangeUpdateFetch = useCallback(async (rowIndex: number, keyValue: string, value: string) => {
        await onChangeFetch(rowIndex, keyValue, value)
        await getCompleteData()
    }, [getCompleteData, onChangeFetch])


    const deleteLine = useCallback(async (id: number) => {
        await twinFetchPostText(inputTableURLs.delete, {
            id,
        })
        getCompleteData()
    }, [getCompleteData, inputTableURLs.delete])

    return { onChangeTotals, onChangeTotalsFetch, onChange, onChangeFetch, onChangeAdd, onChangeUpdate, onChangeUpdateFetch, addNewProductLine, deleteLine, changeOrder, changeSingleField}
}